import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass, createSlots as _createSlots, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "text-center mb-5" }, " Bạn có chắc muốn xoá dữ liệu này? ", -1)
const _hoisted_2 = { class: "card-body p-9" }
const _hoisted_3 = { class: "row d-flex mt-10 mb-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, null, -1)
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "w-100 text-center pr-120" }, "Phiếu xuất kho", -1)
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, " Xuất tại kho: ", -1)
const _hoisted_10 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_11 = {
  key: 2,
  class: "flex align-items-center mb-0"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "Phiếu xuất kho số:", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, " BBGT: ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, " Lý do xuất kho: ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, " Số biên bản: ", -1)
const _hoisted_16 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmHoanThanh = _resolveComponent("ConfirmHoanThanh")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_PhieuXuatKhoPrintModal = _resolveComponent("PhieuXuatKhoPrintModal")!
  const _component_SupplyGettingDetail = _resolveComponent("SupplyGettingDetail")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_button_custom = _resolveComponent("button-custom")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ResponsiveLayout = _resolveComponent("ResponsiveLayout")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_TaiKhoanSelectionV2 = _resolveComponent("TaiKhoanSelectionV2")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_SuppliesTable = _resolveComponent("SuppliesTable")!
  const _component_SuppliesFromWarehouses = _resolveComponent("SuppliesFromWarehouses")!
  const _component_PageRowLayout = _resolveComponent("PageRowLayout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmHoanThanh, {
      for: 'phieu_xuat',
      "phieu-xuat-data": _ctx.phieuXuatDetail,
      show: _ctx.showHoanThanhPhieuXuatModal,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showHoanThanhPhieuXuatModal = false)),
      onConfirm: _ctx.confirmHoanThanh
    }, null, 8, ["phieu-xuat-data", "show", "onConfirm"]),
    _createVNode(_component_ConfirmationDialog, {
      title: `Phiếu xuất số ${_ctx.phieuXuatDetail.so_phieu}`,
      "is-display": _ctx.showConfirmDeleteModal,
      width: "20%",
      onOnCloseButtonClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showConfirmDeleteModal = false)),
      onOnCloseIconClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showConfirmDeleteModal = false)),
      onOnConfirmButtonClick: _ctx.confirmDelete
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["title", "is-display", "onOnConfirmButtonClick"]),
    (_ctx.isPhieuXuatDetailPage && _ctx.phieuXuatDetail)
      ? (_openBlock(), _createBlock(_component_PhieuXuatKhoPrintModal, {
          key: 0,
          ref: "phieuXuatKhoPrintModalRef",
          "phieu-xuat-kho-detail": _ctx.phieuXuatDetail
        }, null, 8, ["phieu-xuat-kho-detail"]))
      : _createCommentVNode("", true),
    _createVNode(_component_SupplyGettingDetail, {
      isOpen: _ctx.detailSupplyIndex >= 0,
      supplyData: _ctx.detailSupplyData,
      supplyGettingData: _ctx.detailGettingSupplyData,
      onOnCloseDialog: _ctx.resetSupplyViewDetail
    }, null, 8, ["isOpen", "supplyData", "supplyGettingData", "onOnCloseDialog"]),
    _createVNode(_component_PageRowLayout, null, {
      "page-row-header": _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.titleComputed), 1)
      ]),
      "page-row-action-button": _withCtx(() => [
        (_ctx.isPhieuXuatDetailPage)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.showHoanThanhPhieuXuat && !_ctx.phieuXuatDetail.ngay_hoan_thanh)
                ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                    key: 0,
                    "button-type": _ctx.ButtonsType.FA_SQUARE_REGULAR,
                    "color-type": _ctx.ButtonTypeColors.PRIMARY,
                    "show-icon": false,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showHoanThanhPhieuXuatModal = true))
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode("Hoàn thành")
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type"]))
                : _createCommentVNode("", true),
              (!_ctx.phieuXuatDetail?.is_approved)
                ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                    key: 1,
                    "button-type": _ctx.ButtonsType.TRASH,
                    "color-type": _ctx.ButtonTypeColors.DANGER,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showConfirmDeleteModal = true))
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode("Xoá")
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type"]))
                : _createCommentVNode("", true),
              (_ctx.editable)
                ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                    key: 2,
                    "button-type": _ctx.ButtonsType.EDIT,
                    "color-type": _ctx.ButtonTypeColors.SUCCESS,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToEditPhieuXuatLink(_ctx.phieuXuatDetail)))
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode("Chỉnh sửa")
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type"]))
                : _createCommentVNode("", true),
              (!_ctx.editable && _ctx.editableTaiKhoan)
                ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                    key: 3,
                    "button-type": _ctx.ButtonsType.EDIT,
                    "color-type": _ctx.ButtonTypeColors.SUCCESS,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToEditPhieuXuatLink(_ctx.phieuXuatDetail)))
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode("Sửa T/k nợ")
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type"]))
                : _createCommentVNode("", true),
              (_ctx.phieuXuatDetail.ngay_hoan_thanh)
                ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                    key: 4,
                    "button-type": _ctx.ButtonsType.FA_CHECK_SQUARE,
                    "color-type": _ctx.ButtonTypeColors.PRIMARY,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showHoanThanhPhieuXuatModal = true))
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode(" Đã Hoàn thành ngày " + _toDisplayString(_ctx.formatDisplayingDate(_ctx.phieuXuatDetail.ngay_hoan_thanh)), 1)
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.isPhieuXuatDetailPage)
          ? (_openBlock(), _createBlock(_component_button_custom, {
              key: 1,
              "button-type": _ctx.ButtonsType.FA_PRINT,
              "color-type": _ctx.ButtonTypeColors.INFO,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.phieuXuatKhoPrintModalRef.isOpen = true))
            }, {
              "button-label": _withCtx(() => [
                _createTextVNode("In Phiếu")
              ]),
              _: 1
            }, 8, ["button-type", "color-type"]))
          : _createCommentVNode("", true),
        _createVNode(_component_button_custom, {
          "button-type": _ctx.ButtonsType.BACK,
          onClick: _ctx.goBack
        }, null, 8, ["button-type", "onClick"])
      ]),
      "page-row-content": _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.form,
          rules: _ctx.rules,
          onSubmit: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("h5", _hoisted_7, " Ngày " + _toDisplayString(new Date().getDate()) + " tháng " + _toDisplayString(new Date().getMonth() + 1) + " năm " + _toDisplayString(new Date().getFullYear()), 1)
                ])
              ]),
              _hoisted_8,
              _createVNode(_component_ResponsiveLayout, null, {
                "col-1": _withCtx(() => [
                  _hoisted_9
                ]),
                "col-2": _withCtx(() => [
                  (!_ctx.isGettingAllSupplies)
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 0,
                        modelValue: _ctx.form.firstWarehouseId,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.firstWarehouseId) = $event)),
                        class: "w-100",
                        disabled: _ctx.isPhieuXuatDetailPage,
                        ref: "warehouseSelection",
                        name: "firstWarehouseId",
                        onChange: _ctx.onWarehouseChangedHandler
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Chưa chọn",
                            value: -1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.khoItems, (kho) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: kho.id,
                              label: kho.ten_kho,
                              value: kho.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled", "onChange"]))
                    : (_ctx.isPhieuLe && _ctx.isGettingAllSupplies)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_10, _toDisplayString(_ctx.selectingTenKho), 1))
                      : (_openBlock(), _createElementBlock("h4", _hoisted_11, [
                          (!_ctx.isPhieuXuatDetailPage)
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 0,
                                modelValue: _ctx.form.firstWarehouseId,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.firstWarehouseId) = $event)),
                                disabled: _ctx.isGettingAllSupplies || _ctx.isPhieuXuatDetailPage,
                                style: {"width":"100%"},
                                ref: "warehouseSelection",
                                name: "firstWarehouseId",
                                onChange: _ctx.onWarehouseChangedHandler
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "Chưa chọn",
                                    value: -1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.khoItems, (kho) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: kho.id,
                                      label: kho.ten_kho,
                                      value: kho.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled", "onChange"]))
                            : (_openBlock(), _createBlock(_component_RouterLink, {
                                key: 1,
                                class: "",
                                to: `/quan-ly/kho/chi-tiet/${_ctx.phieuXuatDetail?.kho?.id}`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.phieuXuatDetail?.kho?.ten_kho || ''), 1)
                                ]),
                                _: 1
                              }, 8, ["to"]))
                        ]))
                ]),
                "col-3": _withCtx(() => [
                  _hoisted_12
                ]),
                "col-4": _withCtx(() => [
                  _createVNode(_component_el_input, {
                    readonly: _ctx.isPhieuXuatDetailPage,
                    disabled: _ctx.isPhieuXuatDetailPage,
                    class: "d-inline w-20",
                    modelValue: _ctx.form.so_phieu,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.so_phieu) = $event)),
                    name: "so_phieu",
                    placeholder: "mời nhập số phiếu xuất ..."
                  }, null, 8, ["readonly", "disabled", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ResponsiveLayout, null, _createSlots({
                "col-1": _withCtx(() => [
                  _createElementVNode("h5", {
                    class: _normalizeClass({ required: !_ctx.isPhieuXuatDetailPage })
                  }, " Người nhận hàng: ", 2)
                ]),
                "col-2": _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "id_nguoi_nhan",
                    class: "mb-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.id_nguoi_nhan,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.id_nguoi_nhan) = $event)),
                        class: "w-100",
                        disabled: _ctx.isPhieuXuatDetailPage,
                        name: "id_nguoi_nhan",
                        onChange: () => {}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Chưa chọn",
                            value: -1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nguoiDungItems, (user) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: user.id,
                              label: user.ho_va_ten,
                              value: user.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, [
                (_ctx.phieuXuatDetail && _ctx.isCreatingFormBierBan)
                  ? {
                      name: "col-3",
                      fn: _withCtx(() => [
                        _hoisted_13
                      ]),
                      key: "0"
                    }
                  : undefined,
                (_ctx.phieuXuatDetail && _ctx.isCreatingFormBierBan)
                  ? {
                      name: "col-4",
                      fn: _withCtx(() => [
                        _createVNode(_component_RouterLink, {
                          to: `/quan-ly/bien-ban-giai-the/chi-tiet/${_ctx.phieuXuatDetail.bien_ban_giai_the?.id ?? _ctx.idBienBan}`,
                          class: "fs-4",
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.phieuXuatDetail.bien_ban_giai_the?.so_bien_ban ?? _ctx.bienBanGiaiTheDetail?.so_bien_ban), 1)
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      key: "1"
                    }
                  : undefined
              ]), 1024),
              _createVNode(_component_ResponsiveLayout, null, {
                "col-1": _withCtx(() => [
                  _hoisted_14
                ]),
                "col-2": _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "receiptReason",
                    class: "mb-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.receiptReason,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.receiptReason) = $event)),
                        readonly: _ctx.isPhieuXuatDetailPage,
                        disabled: true,
                        rows: 1,
                        name: "receiptReason",
                        type: "textarea"
                      }, null, 8, ["modelValue", "readonly"])
                    ]),
                    _: 1
                  })
                ]),
                "col-3": _withCtx(() => [
                  _hoisted_15
                ]),
                "col-4": _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "so_bien_ban",
                    class: "mb-0 w-100"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        readonly: _ctx.isPhieuXuatDetailPage,
                        disabled: true,
                        modelValue: _ctx.form.so_bien_ban,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.so_bien_ban) = $event)),
                        name: "so_bien_ban"
                      }, null, 8, ["readonly", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.isPhieuXuatDetailPage && _ctx.phieuXuatDetail.tk_no)
                ? (_openBlock(), _createBlock(_component_TaiKhoanSelectionV2, {
                    key: 0,
                    label: "Mã TK nợ:",
                    "ma-tai-khoan-prop": _ctx.phieuXuatDetail.tk_no.ma_tk ? parseInt(_ctx.phieuXuatDetail.tk_no.ma_tk) : undefined,
                    "ma-chi-tiet-prop": _ctx.phieuXuatDetail.tk_no.ma_ct ? _ctx.phieuXuatDetail.tk_no.ma_ct : undefined,
                    "read-only": true
                  }, null, 8, ["ma-tai-khoan-prop", "ma-chi-tiet-prop"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createElementVNode("div", _hoisted_16, [
          (
            _ctx.vatTuSelectedInKho.length > 0 &&
            !_ctx.isGettingAllSupplies &&
            !_ctx.isPhieuXuatDetailPage
          )
            ? (_openBlock(), _createBlock(_component_SuppliesTable, {
                key: 0,
                isGettingAllSupplies: _ctx.isGettingAllSupplies,
                "loai-dinh-muc": _ctx.loaiDinhMuc,
                "selecting-kho-item": _ctx.selectingKhoItem,
                supplies: _ctx.vatTuSelected,
                "vat-tu-selected-in-kho": _ctx.vatTuSelectedInKho,
                onOnDetailButtonClick: _ctx.detailButtonClickedHandler,
                onOnNextButtonClick: _ctx.onNextButtonClickedHandler,
                onOnClickClearQuantityData: _ctx.onClearQuantityDataHandler,
                onOnConfirmButtonClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onSubmit()))
              }, null, 8, ["isGettingAllSupplies", "loai-dinh-muc", "selecting-kho-item", "supplies", "vat-tu-selected-in-kho", "onOnDetailButtonClick", "onOnNextButtonClick", "onOnClickClearQuantityData"]))
            : _createCommentVNode("", true),
          (_ctx.isGettingAllSupplies && !_ctx.isPhieuXuatDetailPage)
            ? (_openBlock(), _createBlock(_component_SuppliesFromWarehouses, {
                key: 1,
                items: _ctx.selectedWarehouses,
                "is-phieu-xuat-le": _ctx.isPhieuLe,
                onOnClickClearQuantityData: _ctx.onClearQuantityDataHandler,
                onOnConfirmButtonClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onSubmit()))
              }, null, 8, ["items", "is-phieu-xuat-le", "onOnClickClearQuantityData"]))
            : _createCommentVNode("", true),
          (_ctx.isPhieuXuatDetailPage)
            ? (_openBlock(), _createBlock(_component_SuppliesFromWarehouses, {
                key: 2,
                items: _ctx.selectedWarehouses,
                "is-view-only": true
              }, null, 8, ["items"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ], 64))
}